import { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../../contexts/LanguageContext';
import { FolderOpen, Package, CheckCircle, Users, Layers } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DashboardPage() {
  const { t } = useLanguage();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stats`)
      .then(res => setStats(res.data))
      .catch(console.error);
  }, []);

  const cards = [
    { label: t('totalCategories'), value: stats?.categories || 0, icon: FolderOpen, color: 'bg-blue-50 text-[#0056A6]' },
    { label: t('totalSubcategories'), value: stats?.subcategories || 0, icon: Layers, color: 'bg-indigo-50 text-indigo-600' },
    { label: t('totalProducts'), value: stats?.products || 0, icon: Package, color: 'bg-emerald-50 text-emerald-600' },
    { label: t('activeProducts'), value: stats?.active_products || 0, icon: CheckCircle, color: 'bg-amber-50 text-amber-600' },
    { label: t('totalUsers'), value: stats?.users || 0, icon: Users, color: 'bg-purple-50 text-purple-600' },
  ];

  return (
    <div className="fade-in" data-testid="dashboard-page">
      <h1 className="text-2xl font-bold text-slate-900 mb-6">{t('dashboard')}</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((card, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl border border-slate-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)] p-5 slide-up"
            style={{ animationDelay: `${idx * 0.05}s` }}
            data-testid={`stat-card-${idx}`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm font-medium text-slate-500">{card.label}</span>
              <div className={`w-9 h-9 rounded-lg ${card.color} flex items-center justify-center`}>
                <card.icon className="h-4 w-4" />
              </div>
            </div>
            <p className="text-3xl font-bold text-slate-900">{card.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
